import { lazyWithRetry } from 'components/lazyUtil.js'

const ListBikeForm = lazyWithRetry(() => import('../../list/motorcycle/create/listMotorcycleFormWizard.js'))
const CalculatorLandingPage = lazyWithRetry(() => import('../../list/motorcycle/cost/CalculatorLandingPage.js'))
// IMPORTANT //
// In Future: whenever new route path is added ensure to update "validPaths" in /server/validRoutes.js
const routes = [
  {
    path: '/list/motorcycle',
    component: ListBikeForm,
    is_private: true,
  },
  {
    path: '/list/motorcycle/edit/:bikeID',
    component: ListBikeForm,
    is_private: true,
  },
  {
    path: '/list/motorcycle/:step?',
    component: ListBikeForm,
    is_private: true,
  },
  {
    path: '/list/motorcycle/edit/:bikeID/:step?',
    component: ListBikeForm,
    is_private: true,
  },
  {
    path: '/list-your-motorcycle/calculator',
    component: CalculatorLandingPage,
    is_private: false,
  },
]

export default routes
